import { SearchFacetMapper } from './search-facet.mapper';
import { AutocompleteFiltersMapper } from './autocomplete-filters.mapper';
import { HighlightingMapper } from './highlighting.mapper';
import { SearchSortMapper } from './search-sort.mapper';
import { FieldsMapper } from './fields.mapper';
import { SearchQueryParamsMapper } from './search-query-params.mapper';
import { SpatialFilterMapper } from './spatial-filter.mapper';

export const SEARCH_FACET_MAPPER = new SearchFacetMapper();
export const AUTOCOMPLETE_FILTERS_MAPPER = new AutocompleteFiltersMapper();
export const HIGHLIGHTING_MAPPER = new HighlightingMapper();
export const SEARCH_SORT_MAPPER = new SearchSortMapper();
export const FIELDS_MAPPER = new FieldsMapper();
export const SEARCH_QUERY_PARAMS_MAPPER = new SearchQueryParamsMapper();
export const SPATIAL_FILTER_MAPPER = new SpatialFilterMapper();
